import { siteOffersAccount } from '../lib/public-router'
import { Notice } from '../ui'
import { AccountLinkRequest } from './AccountLinkRequest'
import { givingChoiceOffered } from './kiosk'

export function DonateNotAccepting({
  orgShortId,
  kiosk,
}: {
  orgShortId: string
  kiosk: boolean
}) {
  return (
    <>
      <Notice tone="info">
        We are not set up to accept online donations yet.
      </Notice>
      {siteOffersAccount() && givingChoiceOffered('account', kiosk) ? (
        // A member's account does not wait on taking cards: its statement,
        // membership and the ways to pay by hand are all on the page the link
        // opens.
        <AccountLinkRequest
          orgId={orgShortId}
          ask="Already a member? Where should we send your account link?"
        />
      ) : null}
    </>
  )
}
